<template>
<v-layout>
  <v-flex xs12>
    <v-card>
      <v-toolbar card>
        <v-toolbar-title>
          <v-layout>
            <v-btn flat icon @click="$_getPrevReports()">
              <v-icon dark>keyboard_arrow_left</v-icon>
            </v-btn>
            <v-menu :close-on-content-click="true">
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="searchMonth"
                  hide-details
                  v-on="on"/>
              </template>
              <v-date-picker
                v-model="searchMonth"
                no-title
                type="month"
                locale="ko"
                @change="$_getReports"/>
            </v-menu>
            <v-btn flat icon @click="$_getNextReports()">
              <v-icon dark>keyboard_arrow_right</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
          </v-layout>
        </v-toolbar-title>
      </v-toolbar>
      <v-divider></v-divider>
      <v-progress-linear v-show="loading.main" color="blue" indeterminate height="2" style="margin: 0 auto"/>
      <v-sheet style="max-height:75vh;" class="scroll-y pa-2">
        <table class="charger-status" border="0">
          <template v-for="(districtName, districtIndex) in districtsArray">
            <!-- TODO 템플릿 loop 로 정리 할 것 -->

            <template v-for="(rowNum, rowIndex) in $_getDistrictRowSize(districtName)">
              <tr :key="districtIndex + '-' + rowIndex">
                <th v-if="rowIndex == 0"
                  :rowspan="$_getDistrictRowSize(districtName)">
                  {{ $_getDistrict(districtName).name }}
                </th>

                <td-place v-for="(colNum, colIndex) in columnSize"
                  :key="colIndex + (rowIndex * columnSize)"
                  :place="$_getPlaceAt(districtName, rowIndex, colIndex)"
                  :checker="$_getCheckerAt(districtName, rowIndex, colIndex)"
                  :charger="$_getChargerAt(districtName, rowIndex, colIndex)"
                  :plug="$_getPlugAt(districtName, rowIndex, colIndex)"
                  :checkReports="$_getCheckReportsAt(districtName, rowIndex, colIndex)"
                  :chargingReports="$_getChargingReportsAt(districtName, rowIndex, colIndex)"
                  :plugStatus="$_getPlugStatusAt(districtName, rowIndex, colIndex)"></td-place>
              </tr>
            </template>

          </template>
        </table>
      </v-sheet>
      <v-footer class="pa-2" dark color="primary">
        <!--
        <v-flex xs6 left class="text-xs-left">
          충전소 {{places.length}} &nbsp;
          충전기 {{chargerCount}} &nbsp;
          플러그 {{plugCount}} (offline : {{offlinePlugCount}})
        </v-flex>
        <v-flex xs6 right class="text-xs-right">
          충전회수 {{monthPlugReportCount}} ( {{(monthPlugReportCount / day).toFixed(1)}}회 / 일 )&nbsp;
          점검회수 {{monthChargerReportCount}} ( {{(monthChargerReportCount / day).toFixed(1)}}회 / 일)
        </v-flex>
        -->
      </v-footer>
    </v-card>
  </v-flex>
</v-layout>
</template>

<script>
import moment from 'moment/moment'
import ChargerStatusItem from './ChargerStatusItem'
import {Util} from '../Util'
import Districts from '../Model/Districts'

const tdPlace = {
  props: ['place', 'charger', 'checker', 'plug', 'checkReports', 'chargingReports', 'plugStatus'],
  components: {
    'charger-status-item': ChargerStatusItem
  },
  created () {
    if (this.place && this.place.name === '복합터미널') console.log(this.place.name + 'created')
  },
  updated () {
    if (this.place && this.place.name === '복합터미널') {
      console.log(this.place.name + 'updated ' +
        (this.checkReports ? this.checkReports.length : -1) +
        ' : ' +
        (this.chargingReports ? this.chargingReports.length : -1) +
        ' : ' +
        (this.plugStatus ? this.plugStatus.online : -1)
      )
    }
  },
  watch: {
    checkReports (to, from) {
      if (to !== from) {
        if (this.place && this.place.name === '복합터미널') {
          console.log('checkReports change', from, to)
        }
      }
    },
    chargingReports (to, from) {
      if (to !== from) {
        if (this.place && this.place.name === '복합터미널') {
          console.log('chargingReports change', from, to)
        }
      }
    },
    plugStatus (to, from) {
      if (to !== from) {
        if (this.place && this.place.name === '복합터미널') {
          console.log('plugStatus change', this.place.name, from, to)
        }
      }
    }
  },
  template: `
    <td>
      <template v-if="place">
        <v-tooltip top v-once>
          <template v-slot:activator="{ on }">
            <span v-on="on" class="place-name">{{ place.name }}</span>
          </template>
          <span>{{ place.name }}</span>
        </v-tooltip>
        <div style="text-align:center">
          <span v-if="checker" small>{{ checker.name }}</span>
          <v-icon v-else>person_add</v-icon>
          <br>
          <template v-if="charger">
            <charger-status-item
              :charger="charger"
              :plug="plug"
              :checkReports="checkReports"
              :chargingReports="chargingReports"
              :plugStatus="plugStatus" />
          </template>
        </div>
      </template>
    </td>
  `
}

export default {
  mixins: [Districts],
  name: 'ChargerStatus',
  props: {
    columnSize: {
      type: Number,
      default () {
        return 10
      }
    }
  },
  data () {
    return {
      districtsArray: [],
      chargingReports: {}, // map 은 반응형이 안되니 object 로 처리
      checkReports: {},
      plugStatuses: {},
      loading: {main: false},
      searchMonth: moment().format('YYYY-MM')
    }
  },
  computed: {
    // empty
  },
  watch: {
    '$route' (to, from) {
      this.$_getReports()
    },
    chargingReports (to, from) {
      console.log('chargingReports updated : ' + from.size + ' -> ' + to.size)
    },
    checkReports (to, from) {
      console.log('checkReports updated : ' + from.size + ' -> ' + to.size)
    },
    plugStatuses (to, from) {
      console.log('plugStatuses updated : ' + from.size + ' -> ' + to.size)
    }
  },
  components: {
    'td-place': tdPlace
  },
  created () {
    this.$emit('title', '충전 현황')
    this.$_getData()
  },
  destroyed () {
    if (this.chargingReportCallback) {
      this.chargingReportCallback() // 기존 callback 해제
    }

    if (this.checkReportsCallback) {
      this.checkReportsCallback() // 기존 callback 해제
    }

    if (this.plugStatusCallback) {
      this.plugStatusCallback() // 기존 callback 해제
    }
  },
  methods: {
    // 충전기 중심일 경우
    async $_getData () {
      this.loading.main = true

      const places = await this.$_getPlaces()
      this.districts = await this.$_getDistricts(places)
      this.$_setPlaces(this.districts, places)

      const chargers = await this.$_getChargers()
      this.$_setChargers(this.districts, chargers)

      const plugs = await this.$_getPlugs() // $_getCharger() 가 완료되면
      this.$_setPlugs(this.districts, plugs)

      const checkers = await this.$_getCheckers()
      this.$_setCheckers(this.districts, checkers)

      this.districtsArray = [...this.districts.keys()]
      this.districtsArray.sort() // memory 문제로 this.districts 를 반응형으로 두지 않고 districtsArray 를 사용함

      this.$_getReports()

      this.loading.main = false
    },
    $_getDistrict (districtName) {
      return this.districts.get(districtName)
    },
    $_getDistrictRowSize (districtName) {
      if (this.districts.has(districtName)) {
        return (parseInt((this.districts.get(districtName).chargers.size - 1) / this.columnSize) + 1)
      } else {
        return 0
      }
    },
    $_getPlaceAt (districtName, rowIndex, colIndex) {
      const charger = this.$_getChargerAt(districtName, rowIndex, colIndex)
      if (charger) {
        return charger.place
      } else {
        return null
      }
    },
    $_getChargerAt (districtName, rowIndex, colIndex) {
      if (this.districts.has(districtName)) {
        try {
          let chargers = [...this.districts.get(districtName).chargers.values()]
          return chargers[colIndex + (rowIndex * this.columnSize)]
        } catch (e) {
          return null
        }
      } else {
        return null
      }
    },
    $_getPlugAt (districtName, rowIndex, colIndex) {
      const charger = this.$_getChargerAt(districtName, rowIndex, colIndex)
      if (charger) {
        return charger.plug
      } else {
        return null
      }
    },
    $_getCheckerAt (districtName, rowIndex, colIndex) {
      const place = this.$_getPlaceAt(districtName, rowIndex, colIndex)
      if (place) {
        return place.checker
      } else {
        return null
      }
    },
    $_getCheckReportsAt (districtName, rowIndex, colIndex) {
      const charger = this.$_getChargerAt(districtName, rowIndex, colIndex)
      if (charger) {
        return this.checkReports[charger.id]
      } else {
        return []
      }
    },
    $_getChargingReportsAt (districtName, rowIndex, colIndex) {
      const charger = this.$_getChargerAt(districtName, rowIndex, colIndex)
      if (charger) {
        return this.chargingReports[charger.id]
      } else {
        return []
      }
    },
    $_getPlugStatusAt (districtName, rowIndex, colIndex) {
      const charger = this.$_getChargerAt(districtName, rowIndex, colIndex)
      if (charger) {
        if (this.plugStatuses[charger.id]) {
          return this.plugStatuses[charger.id]
        } else if (typeof charger.plug !== 'undefined') {
          return charger.plug.status
        } else {
          // console.log(charger)
          return null
        }
      } else {
        return null
      }
    },
    $_getReports () {
      this.$_getPlugStatuses()
      this.$_getChargingReports()
      this.$_getCheckReports()
    },

    $_getPrevReports () {
      this.searchMonth = moment(this.searchMonth, 'YYYY-MM').subtract(1, 'month').format('YYYY-MM')
      this.$_getReports()
    },

    $_getNextReports () {
      this.searchMonth = moment(this.searchMonth, 'YYYY-MM').add(1, 'month').format('YYYY-MM')
      this.$_getReports()
    },

    $_getChargingReports () {
      if (this.chargingReportsCallback) {
        this.chargingReportsCallback() // 기존 callback 해제
      }

      this.chargingReports = {}
      // this.chargingReports.clear()
      this.chargingReportsCallback =
        this.$fs
          .collection('plug_reports')
          .where('group', '==', this.$store.state.session.group)
          .where('created', '>=', moment(this.searchMonth, 'YYYY-MM').startOf('month').toDate())
          .where('created', '<=', moment(this.searchMonth, 'YYYY-MM').endOf('month').toDate())
          .orderBy('created', 'asc')
          .onSnapshot((querySnapshot) => {
            // const chargingReports = new Map()

            querySnapshot.docChanges().forEach(change => {
              const report = change.doc.data()
              delete report.logs

              if (report.chargerRef) {
                const {values, duration, wh} = Util.Plug.parseValue(report.values)
                // console.log(values, duration, wh)
                report.values = values
                report.duration = duration
                report.wh = wh

                if (change.type === 'added' || change.type === 'modified') {
                  // console.log('New checkReports: ', change.doc.data())
                  /*
                  if (!this.chargingReports.has(report.chargerRef.id)) {
                    this.chargingReports.set(report.chargerRef.id, [report])
                    console.log('chargingReports updated: ', report.chargerRef.id)
                  } else {
                    this.chargingReports.get(report.chargerRef.id).push(report)
                  }
                  */

                  if (!this.chargingReports[report.chargerRef.id]) {
                    this.$set(this.chargingReports, report.chargerRef.id, [Object.freeze(report)]) // https://kdydesign.github.io/2019/04/10/vuejs-performance/
                  } else {
                    this.chargingReports[report.chargerRef.id].push(Object.freeze(report))
                  }
                  // console.log(report.chargerRef.id, this.chargingReports)
                } else if (change.type === 'removed') {
                  console.log('Removed chargingReports: ', change.doc.data())
                }

                /*
                if (!chargingReports.has(report.chargerRef.id)) { // 충전정보는 플러그가 아닌 충전기에 종속시킴 (중간에 플러그가 바뀔수 있음)
                  chargingReports.set(report.chargerRef.id, [])
                }

                chargingReports.get(report.chargerRef.id).push(report)
                */
              }
            })

            // this.chargingReports = chargingReports
          }, error => {
            if (error) {
              // TODO 오류 처리
              console.log(error)
            }
          })
    },

    $_getCheckReports () {
      if (this.checkReportsCallback) {
        this.checkReportsCallback() // 기존 callback 해제
      }

      this.checkReports = {}
      // this.checkReports.clear()
      this.checkReportsCallback =
        this.$fs
          .collection('reports')
          .where('group', '==', this.$store.state.session.group)
          .where('created', '>=', moment(this.searchMonth, 'YYYY-MM').startOf('month').toDate())
          .where('created', '<=', moment(this.searchMonth, 'YYYY-MM').endOf('month').toDate())
          .orderBy('created', 'asc')
          .onSnapshot((querySnapshot) => {
            // const checkReports = new Map()

            querySnapshot.docChanges().forEach(change => {
              const report = change.doc.data()

              if (report.chargerRef) {
                if (change.type === 'added' || change.type === 'modified') {
                  // 여기서 cell 의 index 를 찾아 바로 넣을 것
                  // modified 에서는 해당 셀의 데이터를 다이렉트로 수정
                  // this.$set(this.checkReports, 'index', value)
                  //
                  // console.log('New checkReports: ', change.doc.data())

                  /*
                  if (!this.checkReports.has(report.chargerRef.id)) {
                    this.checkReports.set(report.chargerRef.id, [report])
                  } else {
                    this.checkReports.get(report.chargerRef.id).push(report)
                  }
                  */

                  if (!this.checkReports[report.chargerRef.id]) {
                    this.$set(this.checkReports, report.chargerRef.id, [Object.freeze(report)]) // https://kdydesign.github.io/2019/04/10/vuejs-performance/
                  } else {
                    this.checkReports[report.chargerRef.id].push(Object.freeze(report))
                  }
                } else if (change.type === 'removed') {
                  console.log('Removed checkReports: ', change.doc.data())
                }
                /*
                if (!this.checkReports.has(report.chargerRef.id)) {
                  this.checkReports.set(report.chargerRef.id, [])
                }

                this.checkReports.get(report.chargerRef.id).push(report)
                */
              }
            })

            console.log('_getCheckReports called')
            // this.checkReports = checkReports
          }, error => {
            if (error) {
              // TODO 오류 처리
              console.log(error)
            }
          })
    },

    $_getPlugStatuses () {
      if (this.plugStatusCallback) {
        this.plugStatusCallback() // 기존 callback 해제
      }

      this.plugStatuses = {}
      // this.plugStatuses.clear()
      this.plugStatusCallback =
        this.$fs
          .collection('plugs')
          .where('group', '==', this.$store.state.session.group)
          .onSnapshot((querySnapshot) => {
            // const plugStatuses = new Map()

            querySnapshot.docChanges().forEach(change => {
              let plug = change.doc.data()

              if (plug.chargerRef) {
                if (change.type === 'added' || change.type === 'modified') {
                  // console.log('New PlugStatus: ', change.doc.data())
                  // this.plugStatuses.set(plug.chargerRef.id, plug.status)
                  this.$set(this.plugStatuses, plug.chargerRef.id, Object.freeze(plug.status)) // https://kdydesign.github.io/2019/04/10/vuejs-performance/
                } else if (change.type === 'removed') {
                  console.log('Removed PlugStatus: ', change.doc.data())
                }

                /*
                if (!this.plugStatuses.has(plug.chargerRef.id)) {
                  this.plugStatuses.set(plug.chargerRef.id, plug.status)
                }
                */
                // console.log('_getPlugStatuses updated', plug.name, plug.status)
              }
            }) // forEach

            // console.log('_getPlugStatuses updated')
            // this.plugStatuses = plugStatuses
          }, error => {
            if (error) {
              // TODO 오류 처리
              console.log(error)
            }
          })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
table.charger-status {
  border-collapse: collapse;
  width: 100%;
}

.charger-status th, .charger-status td {
  border: 1px solid darkgray;
  height: 50px;
  padding: 4px;
}

.charger-status td {
  vertical-align: top;
  min-width: 110px;
  height: 100px;
}

span.place-name {
  overflow: hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
  width:100px;
  display:inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Charger/ChargerStatus.vue